import React,{memo,Fragment} from 'react'

//Router
import { Link, useLocation } from 'react-router-dom'

//React-bootstrap
import { Nav, Tooltip, OverlayTrigger } from 'react-bootstrap'

const SidebarMenu = memo((props) => {
    //location
    let location = useLocation();
    // Sub-menu links carry a query (e.g. /dashboard/upload/upload-files?__card__=BRC), so match on path + query too.
    const isActive = location.pathname === props.pathname || `${location.pathname}${location.search}` === props.pathname;
    const disabledStyle = props.disabled ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {};
  return (
    <Fragment>
      {props.isTag === 'true' &&
        <li className={`${isActive ? 'active' : ''} nav-item ${props.disabled ? 'disabled' : ''}`}>
          <Link 
            className={`${isActive ? 'active' : ''} nav-link `} 
            aria-current="page" 
            to={props.disabled ? '#' : props.pathname}
            onClick={(e) => {
              if (props.disabled) {
                e.preventDefault();
              }
            }}
            style={disabledStyle}
          >
              <OverlayTrigger placement="right" overlay={<Tooltip>{props.disabled ? 'Access restricted' : props.title}</Tooltip>}>
                {props.children}
              </OverlayTrigger>
              <span className="item-name">{props.title}</span>
          </Link>
      </li>
      }
      {
        props.isTag === 'false' &&
        <Nav.Item as="li" className={props.disabled ? 'disabled' : ''}>
          <Link 
            className={`${isActive ? 'active' : ''} nav-link`} 
            to={props.disabled ? '#' : props.pathname} 
            onClick={(e) => {
              if (props.disabled) {
                e.preventDefault();
                return;
              }
              if (props.modalopen) props.modalopen(e);
            }} 
            target={props.disabled ? undefined : props.target}
            style={disabledStyle}
          >
              { props.staticIcon === 'true' &&
                <i className="icon">
                  <svg className="icon-10" xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                      <g>
                          <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                      </g>
                  </svg>
                </i>
              }
              {props.children}
              <OverlayTrigger placement="right" overlay={<Tooltip>{props.disabled ? 'Access restricted' : props.title}</Tooltip>}>
                  <i className="sidenav-mini-icon" > {props.minititle} </i>
              </OverlayTrigger>
              <span className="item-name"> {props.title} </span>
          </Link>
        </Nav.Item>
      }
    </Fragment>
  )
})

SidebarMenu.displayName = "SidebarMenu"
export default SidebarMenu       